import {
  DocumentSource,
  OrderDetail,
  OrderStatus
} from '@insurance/api/requests'
import {
  EFFECTIVE_DATE_VALID_AFTER,
  EFFECTIVE_DATE_VALID_BEFORE
} from '@insurance/app-constants'
import { ProductCode } from '@insurance/types'
import { Modal } from 'antd'
import dayjs from 'dayjs'
import { TFunction } from 'i18next'

type EffectiveDateResponse = {
  minDate?: dayjs.Dayjs
  maxDate?: dayjs.Dayjs
}

export const getEffectiveDateRange = (order?: OrderDetail) => {
  const res: EffectiveDateResponse = {
    minDate: undefined,
    maxDate: undefined
  }

  if (!order) return res

  const isBeforeValidFrom = dayjs(order.valid_from)
    .add(EFFECTIVE_DATE_VALID_AFTER, 'day')
    .isBefore()

  if (isBeforeValidFrom)
    res.minDate = dayjs().add(EFFECTIVE_DATE_VALID_AFTER, 'day')
  else
    res.minDate = dayjs(order.valid_from).add(EFFECTIVE_DATE_VALID_AFTER, 'day')

  res.maxDate = dayjs(order.valid_to).subtract(
    EFFECTIVE_DATE_VALID_BEFORE,
    'day'
  )

  return res
}

export const getOnlineOrderPermissionFlow = (order?: OrderDetail) => {
  return !(
    order?.status !== OrderStatus.INSPECTION ||
    ![ProductCode.CASCO, ProductCode.PROPERTY].includes(
      order?.product?.code as ProductCode
    ) ||
    order.source !== DocumentSource.WEBSITE
  )
}

export const goToEditStep = (order?: OrderDetail, t?: TFunction) => {
  const canSetInitialAgent =
    order?.status === OrderStatus.SUBMITTED && !order?.agent

  const showWarning = async () => {
    if (!canSetInitialAgent) {
      return true
    }

    return new Promise<boolean>((resolve) => {
      Modal.confirm({
        title: t?.('continue_edit_warning'),
        okText: t?.('continue'),
        onOk: () => resolve(true),
        onCancel: () => resolve(false)
      })
    })
  }

  return {
    canSetInitialAgent,
    showWarning
  }
}
